/* eslint-disable max-lines-per-function */
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { formatHourDecimalToTimeString } from '@/domain/dienstplan/features/VisualEditor/utils/timeHelper/formatHourDecimalToTimeString';
import {
  Belegung,
  BelegungsIntervall,
} from '@/domain/dienstplan/shared/types/Belegung';
import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import { mapWochentagForAPI } from '@/domain/dienstplan/shared/utils/mapWochentagForAPI';
import { toast } from '@/hooks/use-toast';

export function endBelegungCreate({ ctx }: { ctx: SharedContext }) {
  const {
    belegungen,
    store: {
      removeBelegungById,
      setStartBelegungPosition,
      updateBelegungById,
      setIsCreatingNewBelegung,
    },
  } = ctx;

  const activeBelegung = belegungen.find((b) => b.mode === 'active');
  if (!activeBelegung) return;

  const inactiveInterval = new BelegungsIntervall(
    activeBelegung.belegung,
    'inactive',
  );
  updateBelegungById(inactiveInterval, inactiveInterval.belegung.id);
  setStartBelegungPosition(undefined);
  setIsCreatingNewBelegung(false);

  if (
    activeBelegung.belegung.start === activeBelegung.belegung.ende ||
    activeBelegung.belegung.personenanzahlMax === 0
  ) {
    removeBelegungById(activeBelegung.belegung.id);
  } else {
    ctx
      .createBelegung({
        input: {
          anzahlMitarbeiter: activeBelegung.belegung.personenanzahlMax,
          arbeitsbereichId: activeBelegung.belegung.arbeitsbereich.id,
          tag: mapWochentagForAPI(ctx.weekday as Weekday),
          dauer: activeBelegung.width * 60,
          von: formatHourDecimalToTimeString(activeBelegung.belegung.start, 0),
          managerId: ctx.manager.id,
        },
      })
      .then((result) => {
        const newBelegungInterval = new BelegungsIntervall(
          new Belegung({
            ...activeBelegung.belegung,
            id: result.data.dienstplan_createBelegungen.id,
          }),
          'inactive',
        );

        updateBelegungById(newBelegungInterval, activeBelegung.belegung.id);

        toast({
          title: ctx.t(
            'domain.dienstplan.mindestbelegung.visualEditor.createSuccess',
          ),
        });
      });
  }
}
